import "./src/css/style.css";
/*! purgecss start ignore */
import "./src/css/prism.css";
/*! purgecss end ignore */
